import type { Column, Content, StyleDictionary } from 'pdfmake/interfaces';
import { pdfTheme } from '../pdfTheme';
import type { BaseReportComponent } from './BaseReportComponent';
import type { ImageReference } from './ImageComponent';
import { ImageWithTitle } from './ImageWithTitle';

const COLUMN_SPACING = pdfTheme.spacing.default;

export class ImageGrid implements BaseReportComponent {
	nodes: BaseReportComponent[] = [];

	constructor(
		private imageGroups: { [title: string]: ImageReference[] },
		private columns = 3,
		private availableWidth = pdfTheme.page.width
	) {}

	exportContent(): Content {
		const rows: Column[][] = [];
		const imageWidth = (this.availableWidth - COLUMN_SPACING * (this.columns - 1)) / this.columns;

		Object.entries(this.imageGroups)
			.sort((a, b) => a[0].localeCompare(b[0]))
			.forEach(([group, imageReferences]) => {
				imageReferences.forEach((imageReference, i) => {
					const image = new ImageWithTitle(group, imageReference, { pageBreak: 'none', width: imageWidth });
					this.nodes.push(image);
				});
			});

		this.nodes.forEach((node, i) => {
			if (i % this.columns === 0) {
				rows.push([]);
			}
			const content: Column = node.exportContent();
			content.width = 100 / this.columns + '%';
			rows[rows.length - 1]?.push(content);
		});

		return {
			marginTop: 2,
			marginBottom: 2,
			stack: rows.map((columnSet) => ({
				columns: columnSet,
				columnGap: COLUMN_SPACING,
				marginBottom: 10,
			})),
		};
	}

	exportStyles(): StyleDictionary {
		return {
			imageGridTitle: {
				fontSize: 15,
				bold: true,
				marginBottom: 6,
			},
		};
	}
}
